// Service templates are structural starting points only. No prices, VAT, hourly value or durations are pre-filled.
export const TEMPLATES = [
  { id: "semi", rows: ["prep", "base", "color", "top", "file", "disposable"] },
  { id: "refill", rows: ["prep", "base", "builder", "color", "top", "file", "disposable"] },
  { id: "reconstruction", rows: ["prep", "base", "builder", "color", "top", "file", "disposable"] },
  { id: "manicure", rows: ["prep", "file", "disposable"] },
  { id: "pedicure", rows: ["prep", "file", "disposable"] },
];
